/* eslint-disable react/prop-types */
import React, { useRef, useEffect } from 'react'
import styled from 'styled-components'
import Highcharts from 'highcharts'
import HistogramBellCurve from 'highcharts/modules/histogram-bellcurve'
import { HistogramProps } from './types'

HistogramBellCurve(Highcharts)

/* This component should receive a ref to bind the chart to. The data should be set by the parent component
 using either highcharts setData or addPoint */

const Histogram: React.FC<HistogramProps> = props => {
    const { chart, width, height, legendEnabled, legendRight } = props
    const higchartsDOMEl = useRef(null)

 
    const options: Highcharts.Options = {
        chart: {
            type: 'column',
            backgroundColor: 'transparent',
            spacingBottom: 10,
            spacingTop: 10,
            spacingLeft: 10,
            spacingRight: 10
        },
        title: {
            text: undefined
        },
        legend: {
            maxHeight: 50,
            padding: 5,
            ...configLegend(legendEnabled, legendRight)
        },
        xAxis: {
            max: null
        },
        plotOptions: {
            column: {
                pointPadding: 0,
                borderWidth: 0,
                groupPadding: 0,
                shadow: false
            }
        }
    }

    useEffect(() => {
        if (!chart.current) {
            return
        }

        const newOptions = {
            ...options,
            legend: {
                ...options.legend,
                ...configLegend(legendEnabled, legendRight)
            }
        }
        chart.current.update(newOptions as Highcharts.Options, true, false, false)
    }, [legendEnabled, legendRight])


    useEffect(() => {
        if (chart.current !== null) {
            chart.current.reflow()
        }
    }, [width, height, chart])

    useEffect(() => {
        chart.current = Highcharts.chart(higchartsDOMEl.current, options)

        return () => {
            chart.current.destroy()
            chart.current = null
        }
    }, [chart, higchartsDOMEl])

    return <HighchartsContainer ref={higchartsDOMEl} />
}

function configLegend(
    legendEnabled: boolean,
    legendRight: boolean
): {
    enabled: boolean
    align?: 'center' | 'right'
    verticalAlign?: 'middle' | 'bottom'
    layout?: 'vertical' | 'horizontal'
} {
    if (!legendEnabled) {
        return { enabled: false }
    }

    const options = legendRight
        ? { align: 'right', verticalAlign: 'middle', layout: 'vertical' }
        : { align: 'center', verticalAlign: 'bottom', layout: 'horizontal' }

    return {
        enabled: true,
        ...options
    }
}

export default Histogram

const HighchartsContainer = styled.div`
    height: 100%;
    margin: 0 auto;
`
